(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dc-coverflow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dc-coverflow')) {
    class DcCoverflow extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-index]'));

        if (!this.cards.length) {
          return;
        }

        this.index = 0;
        this.stage = this.querySelector('.dc-coverflow__stage');
        this.draw();

        this.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => this.go(Number(button.dataset.direction)));
        });

        this.cards.forEach((card, index) => {
          card.addEventListener('click', (event) => {
            if (index !== this.index) {
              event.preventDefault();
              this.index = index;
              this.draw();
            }
          });
        });

        this.stage.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(-1);
          if (event.key === 'ArrowRight') this.go(1);
        });

        let touchStartX = 0;
        this.stage.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
        this.stage.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - touchStartX;

          if (Math.abs(distance) > 40) {
            this.go(distance < 0 ? 1 : -1);
          }
        }, { passive: true });

        if (this.dataset.auto === 'true' && this.cards.length > 1) {
          this.timer = setInterval(() => this.go(1), Number(this.dataset.interval) || 5000);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      go(direction) {
        this.index = (this.index + direction + this.cards.length) % this.cards.length;
        this.draw();
      }

      draw() {
        const count = this.cards.length;

        this.cards.forEach((card, index) => {
          let offset = (index - this.index + count) % count;

          if (offset > Math.floor(count / 2)) {
            offset -= count;
          }

          card.dataset.offset = Math.abs(offset) > 2 ? 'hidden' : String(offset);
          card.tabIndex = index === this.index ? 0 : -1;
          card.setAttribute('aria-current', index === this.index ? 'true' : 'false');
        });
      }
    }

    customElements.define('dc-coverflow', DcCoverflow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dc-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dc-product-tabs')) {
    class DcProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab)));
        this.addEventListener('keydown', this.onKeyDown.bind(this));

        this.querySelectorAll('.dc-product-tabs__slider-wrap').forEach((wrap) => {
          const track = wrap.querySelector('.dc-product-tabs__track');

          wrap.querySelectorAll('[data-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              track.scrollBy({ left: Number(button.dataset.direction) * track.clientWidth, behavior: 'smooth' });
            });
          });
        });
      }

      onKeyDown(event) {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          return;
        }

        const current = this.tabs.indexOf(document.activeElement);

        if (current < 0) {
          return;
        }

        event.preventDefault();
        const next = (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus();
        this.activate(this.tabs[next]);
      }

      activate(tab) {
        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== tab.dataset.tab;
        });

        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    customElements.define('dc-product-tabs', DcProductTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
